/**
 * Created by razial on 06.07.2026.
 */

cleverapps.UI.ThumbnailedSprite = cc.Node.extend({
    ctor: function (resource, options) {
        this._super();

        this.options = options || {};

        this.setAnchorPoint(0.5, 0.5);

        this.originalFrame = resource;

        const bundle = bundles[this.originalFrame.getBundleName()];
        this.thumbnailFrame = bundle.frames[`${this.originalFrame.key}_thumb`];

        if (!this.thumbnailFrame) {
            cleverapps.throwAsync(`no thumbnail for resource ${resource}`);
        }

        this.thumbnail = new cc.Sprite(this.thumbnailFrame);
        this.thumbnail.setAnchorPoint(0.5, 0.5);
        this.addChild(this.thumbnail);

        const dimensions = this.originalFrame.getDimensions();
        if (!dimensions) {
            this.setContentSize(this.thumbnail.width, this.thumbnail.height);
            cleverapps.throwAsync(`no dimensions for resource ${resource}`);
        } else {
            this.setContentSize(dimensions.width, dimensions.height);
        }

        this.thumbnail.setPosition(this.width / 2, this.height / 2);
        this.thumbnail.setScale(this.width / this.thumbnail.width || 1, this.height / this.thumbnail.height || 1);

        if (!this.options.deferred) {
            this.load();
        }
    },

    load: function () {
        if (this.loading) {
            return;
        }

        this.loading = true;

        cleverapps.bundleLoader.loadLazyResource(this.originalFrame, this.createListener(this.onOriginalLoaded.bind(this)));
    },

    cleanup: function () {
        this._super();

        cleverapps.bundleLoader.deleteLazyResource(this.originalFrame);
    },

    onOriginalLoaded: function () {
        this.thumbnail.removeFromParent();
        this.thumbnail = undefined;

        this.image = new cc.Sprite(this.originalFrame);
        this.image.setAnchorPoint(0.5, 0.5);
        this.addChild(this.image);

        this.setContentSize(this.image.width, this.image.height);

        this.image.setPosition(this.width / 2, this.height / 2);
    }
});
